import React from 'react';
import Loadable from 'react-loadable';
import {Route, Switch} from 'react-router';
import LoadingComponent from 'src/components/LoadingComponent';

const CampaignManagerRoot = Loadable({
  loader: () => import('src/features/CampaignManager'),
  loading: LoadingComponent
});
const HertzReportingRoot = Loadable({
  loader: () => import('src/features/HertzReporting'),
  loading: LoadingComponent
});
const ExactMatchRoot = Loadable({
  loader: () => import('src/features/ExactMatch'),
  loading: LoadingComponent
});
const BoomerangRoot = Loadable({
  loader: () => import('src/features/Boomerang'),
  loading: LoadingComponent
});

const routes = (
  <Switch>
    <Route path="/campaignmanager" component={CampaignManagerRoot} />
    <Route path="/hertzreporting" component={HertzReportingRoot} />
    <Route path="/exactmatch" component={ExactMatchRoot} />
    <Route path="/boomerang" component={BoomerangRoot} />
    <Route path="/" render={() => <div />} />
  </Switch>
);

export default routes;
